import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { ReactComponent as FileIcon } from "./../../../../../assets/file.svg";
import { useState } from "react";

export const DownloadTemplateFiles = () => {
  const [files, setFiles] = useState<string[]>([
    "CSV File",
    "Excel File",
    "JSON File",
  ]);

  return (
    <Stack spacing={2} sx={{ width: "100%", height: 300, padding: "1.3rem" }}>
      {files.map((file, index: number) => {
        return (
          <Card
            elevation={0}
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "1rem",
              backgroundColor: "#F0F4F8",
              borderRadius: ".8rem",
            }}
          >
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <FileIcon style={{ width: "20px", height: "20px" }} />
              <Typography variant="body2">{file}</Typography>
            </Box>

            <Box>
              <Button variant="contained">Download</Button>
              <Button variant="text">View</Button>
            </Box>
          </Card>
        );
      })}
    </Stack>
  );
};
